import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {floorEdit_template} from "../components/templates/floorEdit_template";
import {header} from "./header";
import { floor_edit } from "./floor_edit";

declare var ko: any;
declare var page: any;

export class floor_copy extends floor_edit{

    /**
     * @inheritDoc
     */
    protected getModuleName(){

        return 'floor_copy';
    }

    /**
     * @inheritDoc
     */
    public buildContent(): Array<Element>{

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Add Floor');

        this.template = new floorEdit_template('floorEdit_template', this.viewModel, this);

        return [this.template.build()];
    }

    //
    // Obtain the dynamic data required to fill the form.
    protected getEditData(takeover: boolean = false): void{

        this.loadingIn(this.template.builtTemplate);

        let id      = this.getVnAppZone().app.params.id;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';

        if(!id){

            this.loadingOut(this.template.builtTemplate);
            return;
        }

        if(idBrand){

            url = `/api/brand/${idBrand}/floors/copy/${id}`;
        }
        else{

            url = `/api/floors/copy/${id}`;
        }

        this.requestHandler = new XMLHttpRequestHandler(url, [['takeover', (takeover) ? '1' : '0']], this);
        this.requestHandler.onReadyStateFunction = this.onEditDataRequestReturn;
        this.requestHandler.execute();
    }
}
